// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6111":"7d80b5c4","6691":"7d80b5c4","8976":"3aba571b"}[chunkId] + ".chunk.css";
};